const BackgroundImage = () => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 1029 682"
            fill="none"
            stroke="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g opacity="0.08" filter="url(#filter0_f_960_3345)">
                <g filter="url(#filter1_d_960_3345)">
                    <circle
                        cx="94.0249"
                        cy="88.0249"
                        r="53.0249"
                        fill="url(#WBGpattern0)"
                    />
                    <circle
                        cx="94.0249"
                        cy="88.0249"
                        r="51.771"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
                <g filter="url(#filter2_d_960_3345)">
                    <circle
                        cx="173.562"
                        cy="88.0249"
                        r="53.0249"
                        fill="url(#WBGpattern1)"
                    />
                    <circle
                        cx="173.562"
                        cy="88.0249"
                        r="51.771"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
            </g>
            <g opacity="0.08" filter="url(#filter3_f_960_3345)">
                <g filter="url(#filter4_d_960_3345)">
                    <circle
                        cx="272.168"
                        cy="353.327"
                        r="53.0249"
                        fill="url(#WBGpattern2)"
                    />
                    <circle
                        cx="272.168"
                        cy="353.327"
                        r="51.771"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
                <g filter="url(#filter5_d_960_3345)">
                    <circle
                        cx="351.705"
                        cy="353.326"
                        r="53.0249"
                        fill="url(#WBGpattern3)"
                    />
                    <circle
                        cx="351.705"
                        cy="353.326"
                        r="51.771"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
            </g>
            <g opacity="0.12" filter="url(#filter6_f_960_3345)">
                <g filter="url(#filter7_d_960_3345)">
                    <circle
                        cx="694.429"
                        cy="77.4286"
                        r="56.4286"
                        fill="url(#WBGpattern4)"
                    />
                    <circle
                        cx="694.429"
                        cy="77.4286"
                        r="55.1746"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
                <g filter="url(#filter8_d_960_3345)">
                    <circle
                        cx="779.071"
                        cy="77.4286"
                        r="56.4286"
                        fill="url(#WBGpattern5)"
                    />
                    <circle
                        cx="779.071"
                        cy="77.4286"
                        r="55.1746"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
            </g>
            <g filter="url(#filter9_d_960_3345)">
                <circle
                    cx="80.0952"
                    cy="213.095"
                    r="30.0952"
                    fill="url(#WBGpattern6)"
                />
                <circle
                    cx="80.0952"
                    cy="213.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter10_d_960_3345)">
                <circle
                    cx="125.238"
                    cy="213.095"
                    r="30.0952"
                    fill="url(#WBGpattern7)"
                />
                <circle
                    cx="125.238"
                    cy="213.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter11_d_960_3345)">
                <circle
                    cx="112.095"
                    cy="457.095"
                    r="30.0952"
                    fill="url(#WBGpattern8)"
                />
                <circle
                    cx="112.095"
                    cy="457.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter12_d_960_3345)">
                <circle
                    cx="157.238"
                    cy="457.095"
                    r="30.0952"
                    fill="url(#WBGpattern9)"
                />
                <circle
                    cx="157.238"
                    cy="457.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter13_d_960_3345)">
                <circle
                    cx="519.095"
                    cy="634.096"
                    r="30.0952"
                    fill="url(#WBGpattern10)"
                />
                <circle
                    cx="519.095"
                    cy="634.096"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter14_d_960_3345)">
                <circle
                    cx="564.238"
                    cy="634.095"
                    r="30.0952"
                    fill="url(#WBGpattern11)"
                />
                <circle
                    cx="564.238"
                    cy="634.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter15_d_960_3345)">
                <circle
                    cx="938.095"
                    cy="204.096"
                    r="30.0952"
                    fill="url(#WBGpattern12)"
                />
                <circle
                    cx="938.095"
                    cy="204.096"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter16_d_960_3345)">
                <circle
                    cx="983.238"
                    cy="204.095"
                    r="30.0952"
                    fill="url(#WBGpattern13)"
                />
                <circle
                    cx="983.238"
                    cy="204.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter17_d_960_3345)">
                <circle
                    cx="485.095"
                    cy="54.0952"
                    r="28.8413"
                    fill="#E0565B"
                    stroke="white"
                    strokeWidth="2.50794"
                />
                <g clipPath="url(#clip0_960_3345)">
                    <path
                        d="M475.305 62.0704C475.466 63.3086 476.27 64.3801 477.395 64.8563C477.946 65.0941 478.543 65.1657 479.14 65.0941C479.714 65.0228 480.289 64.8322 480.886 64.4755C481.713 63.9988 482.539 63.261 483.504 62.1658C481.988 60.2373 481.07 58.4754 480.725 56.9044C480.564 56.1662 480.541 55.4995 480.61 54.8804C480.702 54.2853 480.909 53.7375 481.23 53.2614C481.942 52.1901 483.136 51.571 484.469 51.571C485.801 51.571 486.995 52.2139 487.707 53.2614C488.028 53.7375 488.235 54.2853 488.327 54.8804C488.419 55.4995 488.396 56.19 488.212 56.9044C487.868 58.4754 486.926 60.2611 485.433 62.1893C486.375 63.2848 487.225 64.0229 488.051 64.499C488.648 64.8563 489.223 65.0468 489.797 65.1179C490.417 65.1895 491.014 65.0941 491.542 64.8801C492.668 64.4039 493.471 63.3322 493.632 62.0942C493.701 61.4991 493.655 60.904 493.425 60.2373C493.357 59.999 493.242 59.7614 493.127 59.4755C492.966 59.0947 492.782 58.6897 492.599 58.2849L492.576 58.2375C490.991 54.6899 489.291 51.0711 487.523 47.5477L487.454 47.4045C487.27 47.0477 487.087 46.6669 486.903 46.3097C486.719 45.9287 486.513 45.5714 486.26 45.2617C485.778 44.6902 485.135 44.3808 484.423 44.3808C483.711 44.3808 483.068 44.6902 482.585 45.2617C482.333 45.5714 482.126 45.9287 481.942 46.3097C481.758 46.6669 481.575 47.0477 481.391 47.4045L481.322 47.5477C479.577 51.0949 477.877 54.7137 476.292 58.2613V58.2849C476.109 58.6659 475.948 59.0947 475.764 59.4755C475.649 59.7614 475.535 59.999 475.466 60.2373C475.282 60.8562 475.213 61.4518 475.305 62.0704ZM484.469 60.9513C485.709 59.3326 486.513 57.8087 486.788 56.5234C486.903 55.9757 486.926 55.4995 486.857 55.0709C486.811 54.6899 486.673 54.3564 486.49 54.0705C486.053 53.4283 485.318 53.0228 484.469 53.0228C483.619 53.0228 482.861 53.4041 482.447 54.0705C482.264 54.3564 482.126 54.6899 482.08 55.0709C482.011 55.4995 482.034 55.9994 482.149 56.5234C482.425 57.7852 483.228 59.3088 484.469 60.9513ZM474.111 59.7134C474.226 59.4277 474.34 59.1183 474.455 58.8564C474.639 58.4281 474.823 58.023 474.984 57.642L475.007 57.6184C476.591 54.047 478.291 50.4282 480.082 46.8574L480.151 46.7143C480.335 46.357 480.518 45.976 480.702 45.5952C480.932 45.1664 481.162 44.7145 481.529 44.2856C482.264 43.3333 483.32 42.8096 484.446 42.8096C485.594 42.8096 486.627 43.3333 487.385 44.2383C487.73 44.6667 487.982 45.119 488.212 45.5479C488.396 45.9287 488.58 46.3097 488.763 46.6669L488.832 46.8094C490.6 50.3806 492.323 53.9996 493.908 57.5709L493.931 57.6184C494.091 57.9992 494.275 58.4038 494.459 58.8326C494.574 59.0947 494.689 59.3804 494.803 59.6898C495.102 60.5706 495.194 61.404 495.079 62.2609C494.826 64.0466 493.678 65.5467 492.093 66.2132C491.496 66.4753 490.876 66.5942 490.233 66.5942C490.049 66.5942 489.82 66.5704 489.636 66.5464C488.878 66.451 488.097 66.1896 487.339 65.737C486.398 65.1895 485.502 64.4039 484.492 63.261C483.481 64.4039 482.562 65.1895 481.644 65.737C480.886 66.1896 480.105 66.451 479.347 66.5464C479.163 66.5704 478.934 66.5942 478.75 66.5942C478.107 66.5942 477.464 66.4753 476.89 66.2132C475.282 65.5467 474.157 64.0229 473.904 62.2609C473.72 61.4275 473.812 60.5946 474.111 59.7134Z"
                        fill="white"
                    />
                </g>
            </g>
            <g filter="url(#filter18_d_960_3345)">
                <circle
                    cx="530.238"
                    cy="54.0952"
                    r="30.0952"
                    fill="url(#WBGpattern14)"
                />
                <circle
                    cx="530.238"
                    cy="54.0952"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter19_d_960_3345)">
                <circle
                    cx="871.095"
                    cy="487.095"
                    r="30.0952"
                    fill="url(#WBGpattern15)"
                />
                <circle
                    cx="871.095"
                    cy="487.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g filter="url(#filter20_d_960_3345)">
                <circle
                    cx="916.238"
                    cy="487.095"
                    r="30.0952"
                    fill="url(#WBGpattern16)"
                />
                <circle
                    cx="916.238"
                    cy="487.095"
                    r="28.8413"
                    stroke="white"
                    strokeWidth="2.50794"
                />
            </g>
            <g opacity="0.2" filter="url(#filter21_f_960_3345)">
                <g filter="url(#filter22_d_960_3345)">
                    <circle
                        cx="941.481"
                        cy="353.481"
                        r="16.4807"
                        fill="url(#WBGpattern17)"
                    />
                    <circle
                        cx="941.481"
                        cy="353.481"
                        r="15.2268"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
                <g filter="url(#filter23_d_960_3345)">
                    <circle
                        cx="966.202"
                        cy="353.481"
                        r="16.4807"
                        fill="url(#WBGpattern18)"
                    />
                    <circle
                        cx="966.202"
                        cy="353.481"
                        r="15.2268"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
            </g>
            <g opacity="0.12" filter="url(#filter24_f_960_3345)">
                <g filter="url(#filter25_d_960_3345)">
                    <circle
                        cx="32.4807"
                        cy="265.369"
                        r="16.4807"
                        fill="url(#WBGpattern19)"
                    />
                    <circle
                        cx="32.4807"
                        cy="265.369"
                        r="15.2268"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
                <g filter="url(#filter26_d_960_3345)">
                    <circle
                        cx="57.2018"
                        cy="265.369"
                        r="16.4807"
                        fill="url(#WBGpattern20)"
                    />
                    <circle
                        cx="57.2018"
                        cy="265.369"
                        r="15.2268"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
            </g>
            <g opacity="0.12" filter="url(#filter27_f_960_3345)">
                <g filter="url(#filter28_d_960_3345)">
                    <circle
                        cx="538.481"
                        cy="473.481"
                        r="16.4807"
                        fill="url(#WBGpattern21)"
                    />
                    <circle
                        cx="538.481"
                        cy="473.481"
                        r="15.2268"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
                <g filter="url(#filter29_d_960_3345)">
                    <circle
                        cx="563.202"
                        cy="473.481"
                        r="16.4807"
                        fill="url(#WBGpattern22)"
                    />
                    <circle
                        cx="563.202"
                        cy="473.481"
                        r="15.2268"
                        stroke="white"
                        strokeWidth="2.50794"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_f_960_3345"
                    x="20.9365"
                    y="14.9365"
                    width="225.714"
                    height="146.177"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="10.0317"
                        result="effect1_foregroundBlur_960_3345"
                    />
                </filter>
                <filter
                    id="filter1_d_960_3345"
                    x="25.9524"
                    y="22.4603"
                    width="136.145"
                    height="136.145"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern0"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image0_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter2_d_960_3345"
                    x="105.49"
                    y="22.4603"
                    width="136.145"
                    height="136.145"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern1"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image1_960_3345"
                        transform="scale(0.005)"
                    />
                </pattern>
                <filter
                    id="filter3_f_960_3345"
                    x="199.079"
                    y="280.238"
                    width="225.714"
                    height="146.177"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="10.0317"
                        result="effect1_foregroundBlur_960_3345"
                    />
                </filter>
                <filter
                    id="filter4_d_960_3345"
                    x="204.095"
                    y="287.762"
                    width="136.145"
                    height="136.145"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern2"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image2_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter5_d_960_3345"
                    x="283.633"
                    y="287.762"
                    width="136.145"
                    height="136.145"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern3"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image3_960_3345"
                        transform="scale(0.0153846)"
                    />
                </pattern>
                <filter
                    id="filter6_f_960_3345"
                    x="617.937"
                    y="0.936508"
                    width="237.627"
                    height="152.984"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="10.0317"
                        result="effect1_foregroundBlur_960_3345"
                    />
                </filter>
                <filter
                    id="filter7_d_960_3345"
                    x="622.952"
                    y="8.46032"
                    width="142.952"
                    height="142.952"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern4"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image4_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter8_d_960_3345"
                    x="707.595"
                    y="8.46032"
                    width="142.952"
                    height="142.952"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern5"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image5_960_3345"
                        transform="scale(0.00333333)"
                    />
                </pattern>
                <filter
                    id="filter9_d_960_3345"
                    x="34.9524"
                    y="170.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern6"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image6_960_3345"
                        transform="scale(0.00251256)"
                    />
                </pattern>
                <filter
                    id="filter10_d_960_3345"
                    x="80.0952"
                    y="170.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern7"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image7_960_3345"
                        transform="scale(0.0153846)"
                    />
                </pattern>
                <filter
                    id="filter11_d_960_3345"
                    x="66.9524"
                    y="414.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern8"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image8_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter12_d_960_3345"
                    x="112.095"
                    y="414.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern9"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image9_960_3345"
                        transform="scale(0.0153846)"
                    />
                </pattern>
                <filter
                    id="filter13_d_960_3345"
                    x="473.952"
                    y="591.461"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern10"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image10_960_3345"
                        transform="scale(0.00250627)"
                    />
                </pattern>
                <filter
                    id="filter14_d_960_3345"
                    x="519.095"
                    y="591.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern11"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image11_960_3345"
                        transform="scale(0.0153846)"
                    />
                </pattern>
                <filter
                    id="filter15_d_960_3345"
                    x="892.952"
                    y="161.461"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern12"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image4_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter16_d_960_3345"
                    x="938.095"
                    y="161.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern13"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image12_960_3345"
                        transform="scale(0.0153846)"
                    />
                </pattern>
                <filter
                    id="filter17_d_960_3345"
                    x="439.952"
                    y="11.4603"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter18_d_960_3345"
                    x="485.095"
                    y="11.4603"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern14"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image3_960_3345"
                        transform="scale(0.0153846)"
                    />
                </pattern>
                <filter
                    id="filter19_d_960_3345"
                    x="825.952"
                    y="444.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern15"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image13_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter20_d_960_3345"
                    x="871.095"
                    y="444.46"
                    width="90.2857"
                    height="90.2857"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern16"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image14_960_3345"
                        transform="scale(0.0153846)"
                    />
                </pattern>
                <filter
                    id="filter21_f_960_3345"
                    x="914.968"
                    y="326.968"
                    width="77.7461"
                    height="53.0254"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="5.01587"
                        result="effect1_foregroundBlur_960_3345"
                    />
                </filter>
                <filter
                    id="filter22_d_960_3345"
                    x="909.952"
                    y="324.461"
                    width="63.0567"
                    height="63.0567"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern17"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image13_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter23_d_960_3345"
                    x="934.674"
                    y="324.46"
                    width="63.0567"
                    height="63.0567"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern18"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image15_960_3345"
                        transform="scale(0.00333333)"
                    />
                </pattern>
                <filter
                    id="filter24_f_960_3345"
                    x="5.96825"
                    y="238.857"
                    width="77.746"
                    height="53.0249"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="5.01587"
                        result="effect1_foregroundBlur_960_3345"
                    />
                </filter>
                <filter
                    id="filter25_d_960_3345"
                    x="0.952381"
                    y="236.349"
                    width="63.0567"
                    height="63.0567"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern19"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image13_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter26_d_960_3345"
                    x="25.6735"
                    y="236.349"
                    width="63.0567"
                    height="63.0567"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern20"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image15_960_3345"
                        transform="scale(0.00333333)"
                    />
                </pattern>
                <filter
                    id="filter27_f_960_3345"
                    x="511.968"
                    y="446.968"
                    width="77.7459"
                    height="53.0254"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="5.01587"
                        result="effect1_foregroundBlur_960_3345"
                    />
                </filter>
                <filter
                    id="filter28_d_960_3345"
                    x="506.952"
                    y="444.461"
                    width="63.0567"
                    height="63.0567"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern21"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image13_960_3345"
                        transform="scale(0.0025)"
                    />
                </pattern>
                <filter
                    id="filter29_d_960_3345"
                    x="531.673"
                    y="444.46"
                    width="63.0567"
                    height="63.0567"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.50794" />
                    <feGaussianBlur stdDeviation="7.52381" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_960_3345"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_960_3345"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="WBGpattern22"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlinkHref="#image15_960_3345"
                        transform="scale(0.00333333)"
                    />
                </pattern>
                <clipPath id="clip0_960_3345">
                    <rect
                        width="21.3175"
                        height="23.8254"
                        fill="white"
                        transform="matrix(-1 0 0 1 495.127 42.8096)"
                    />
                </clipPath>
                <image
                    id="image0_960_3345"
                    width="400"
                    height="400"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Microsoft%20Icon%20undefined.png"
                    // Top left blurred 1
                />
                <image
                    id="image1_960_3345"
                    width="200"
                    height="200"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%2038.png"
                    // Top left blurred 2
                />
                <image
                    id="image2_960_3345"
                    width="400"
                    height="400"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Twitter%20Icon%20undefined.png"
                    // Blurred image left of title
                />
                <image
                    id="image3_960_3345"
                    width="65"
                    height="65"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%20482%20(1).png"
                    // Top candidate image
                />
                <image
                    id="image4_960_3345"
                    width="400"
                    height="400"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Apple%20Icon%20undefined.png"
                    // Top right company image
                />
                <image
                    id="image5_960_3345"
                    width="300"
                    height="300"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%2038%20(1).png"
                    // Top right blurred 2
                />
                <image
                    id="image6_960_3345"
                    width="398"
                    height="398"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Figma%20Icon%20undefined.png"
                    // Top left company image
                />
                <image
                    id="image7_960_3345"
                    width="65"
                    height="65"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%20482-4.png"
                    // Top left candidate image
                />
                <image
                    id="image8_960_3345"
                    width="400"
                    height="400"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Party%20Round%20Icon%20undefined%20(1).png"
                    // Bottom left company image
                />
                <image
                    id="image9_960_3345"
                    width="65"
                    height="65"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%20482.png"
                    // Bottom left candidate image
                />
                <image
                    id="image10_960_3345"
                    width="399"
                    height="399"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Plaid%20Icon%20undefined%20(3).png"
                    // Bottom company image
                />
                <image
                    id="image11_960_3345"
                    width="65"
                    height="65"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%20484.png"
                    // Bottom candidate image
                />
                <image
                    id="image12_960_3345"
                    width="65"
                    height="65"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%20482-3.png"
                    // Top right candidate image
                />
                <image
                    id="image13_960_3345"
                    width="400"
                    height="400"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Stripe%20Icon%20undefined.png"
                    // Bottom right company image
                />
                <image
                    id="image14_960_3345"
                    width="65"
                    height="65"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%20482%20(5).png"
                    // Bottom right candidate image
                />
                <image
                    id="image15_960_3345"
                    width="300"
                    height="300"
                    xlinkHref="https://cardea.imgix.net/media/landingpage/talent/welcome/Ellipse%20483.png"
                    // Right blurred image 2
                />
            </defs>
        </svg>
    )
}

export default BackgroundImage
